import {MonitoringServiceChoices} from "@/lib/types/checks.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {PSReportBody} from "@/pages/pagespeed/report/PSReportBody.tsx";
import {PSReportHeader} from "@/pages/pagespeed/report/PSReportHeader.tsx";
import {PSReportMain} from "@/pages/pagespeed/report/PSReportMain.tsx";
import {PSReportRuntimeErrors} from "@/pages/pagespeed/report/PSReportRuntimeErrors.tsx";
import {PSReportWarnings} from "@/pages/pagespeed/report/PSReportWarnings.tsx";
import {NetworkStep, PagespeedLHR, PSReportOptions} from "@/pages/pagespeed/types.ts";

interface PageSpeedStepProps {
  checkID: number;
  checkName: string;
  lhr: PagespeedLHR;
  mspChoices: MonitoringServiceChoices;
  networkSteps?: NetworkStep[];
  performanceGrade?: string;
  options?: PSReportOptions;
  monitoringServer?: MonitoringServer;
}
export const PageSpeedStep = ({
  checkID,
  checkName,
  lhr,
  mspChoices,
  monitoringServer,
  performanceGrade,
  options,
  networkSteps,
}: PageSpeedStepProps) => (
  <div className="step">
    <PSReportHeader checkName={checkName} url={lhr.requestedUrl || lhr.finalDisplayedUrl} />
    <PSReportRuntimeErrors runtimeError={lhr.runtimeError} />
    <PSReportWarnings runWarnings={lhr.runWarnings} />
    <PSReportMain
      id={checkID}
      lhr={lhr}
      mspChoices={mspChoices}
      options={options}
      monitoringServer={monitoringServer}
      performanceGrade={performanceGrade}
    />
    <PSReportBody lhr={lhr} checkID={checkID} networkSteps={networkSteps ?? []} />
  </div>
);
